import { gql } from "@apollo/client";

export const GetBookingTypeStaff = gql`
  query GetBookingTypeStaff($id: Int!) {
    bookingTypeStaff(id: $businessId) {
      id 
    }
  }
`;
